import Customization from "./customization";
import { liquid, StoreCategory } from "./customization/category";
import BaseCustomization from "./customization/base";
import CustomizationRequest from "./customization/request";
import { onCustomizationRendered } from "./customization/event";

// Connects to data-controller="site-builder--images"
export default class extends BaseCustomization {
  static targets = ["selection", "reset"];
  static outlets = ["tabs", "site-builder--custom-images--actions"]
  customizationType = "imageSet";

  initialize() {
    this.tabItem = document.getElementById("for-images");
    onCustomizationRendered(this.#selectTab, { once: true });
  }

  initializeSelection() {
    this.removeSelectedOption();
    const defaultValue = this.values();
    if (defaultValue) {
      this.#selectByValue(defaultValue);
      this.highlightTabSelection();
    }
  }

  applyImageSet(e) {
    const chosen = e.currentTarget;
    const imageSet = chosen.dataset[this.customizationType];

    if (this.isCustomizationSame(chosen)) return;

    const payload = {
      "image-set": imageSet,
      hero: undefined,
      'footer-one': undefined,
      'footer-two': undefined
    };

    this.removeSelectedOption();
    e.currentTarget.classList.add("selected");

    // Cms site builder doesn't require css var updates for images.
    if (!this.isPersisted) Customization.localUpdate(payload, StoreCategory.CSS);

    Customization.serverUpdate(payload);
    this.highlightTabSelection();
    this.showReset();
  }

  reset() {
    const imageSet = {
      "image-set": undefined,
    };
    const imageSetUrls = {
      "hero-url": null,
      "footer-one-url": null,
      "footer-two-url": null,
    };

    const customImagesUrl = {
      hero: undefined,
      'footer-one': undefined,
      'footer-two': undefined
    }

    this.#removeImageCropperDetails();

    // Cms site builder doesn't require css var updates for images.
    if (this.isPersisted) {
      Customization.serverUpdate({ ...customImagesUrl, ...imageSet });
    } else {
      Customization.localUpdate(
        { ...imageSetUrls, ...imageSet },
        StoreCategory.CSS
      );
      Customization.serverUpdate(imageSet);
    }

    this.removeSelectedOption();
    this.removeTabSelection();
    this.hideReset();
  }

  #removeImageCropperDetails() {
    const imageHiddenDivs = document.querySelectorAll('.image-cropper-details');
    imageHiddenDivs.forEach(div => div.remove());
  }

  #selectByValue(payload) {
    this.removeSelectedOption();
    const current = this.selectionTargets.find((selection) => {
      return selection.dataset[this.customizationType] === payload;
    });

    if (current) current.classList.add("selected");
  }

  fetchFromStore() {
    return liquid.imageSet;
  }

  fetchFromPreview() {
    return CustomizationRequest.getCurrentImageSet();
  }

  #selectTab = () => {
    const imageSet = this.fetchFromPreview();
    if(!this.isPersisted) return;

    const noCustomImage = !this.siteBuilderCustomImagesActionsOutlets.find((customImage)=>(customImage.value))

    if(imageSet || noCustomImage){
      this.tabsOutlet.selectByView('image-sets')
    } else{
      this.tabsOutlet.selectByView('custom-images')
    }
  }
}
